function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'0332e77d3d8fc3f52482224fff9e9d0a': 'rgb(0, 0, 128)','4a5103f4ba7b9f9e896bf4afb9315877': 'rgb(0, 0, 128)','de6686a605a3cbd2b4f3a1a80283d360': 'rgb(0, 0, 128)','5eef3dd78da66671a8f46dd404759485': 'rgb(169, 169, 169)','5bf875635eec841cf80d324b65f73b89': 'rgb(224, 255, 255)','cc8d26c4ebbce679c08d306c93b900dc': 'rgb(224, 255, 255)','6d5b0091d29c4940f6060f3d3f056a95': 'rgb(105, 105, 105)','50f72d36da7eb082f2ba4e4d2e6e45e0': 'rgb(169, 169, 169)','9d430b5dd5e079588128e07ea769ae07': 'rgb(169, 169, 169)','893723153a9f931e6cbfb438d18e0f69': 'rgb(255, 218, 185)','bb482a9c91cba46c09b57d0e178e171c': 'rgb(211, 211, 211)','262d711a96d68f827bd0e8be884cdb00': 'rgb(255, 255, 255)','023699b8c3b81962abf0979c7164140d': 'rgb(255, 255, 255)','9574acf8c87ae2be9dbaa85aa469a8f3': 'rgb(0, 0, 0)','9c238148906d7564f888dc7fea405242': 'rgb(0, 0, 0)','3399d7040552634f9dc0d7f4e4a6d759': 'rgb(0, 0, 0)','82977777b0cb94a1bbc4d0ff9dfdd3dd': 'rgb(245, 245, 245)','a6b3f1c744304a3ee2ec20446f690f45': 'rgb(0, 0, 139)','97f014516561ef487ec368d6158eb3f4': 'rgb(245, 245, 245)',};

    this.images = {};
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
